<!-- Show a file uploader instead of a common field for images -->
@if (item.type === ReportTemplateFieldType.Image) {
  <rotec-file-uploader-v2
    [maximumNrOfFiles]="1"
    [acceptedFileFormats]="['.jpg', '.jpeg,', '.png', '.svg']"
    [service]="fileUploader"
    [files]="item?.value || ''"
    [hasLogo]="true"
    type="picture"
    [logoStyles]="{ width: '100%', height: 'auto', minHeight: '85px' }"
    (filesChange)="selectLogo($event)"
    [showDefaultLogo]="true"
    [validatorFnAsync]="logoValidationService.validatePDFLogo"
  >
  </rotec-file-uploader-v2>
} @else {
  <p class="template-toolbox-item-text" translate>{{ item.name }}</p>
}
